import React, { useState } from 'react';
export function Toggle(props) {
  const {
    id,
    name,
    checked,
    onChange,
    onColor,
    onText,
    offColor,
    offText,
    size,
    disabled,
  } = props;

  const handleKeyPress = (e) => {
    if (e.keyCode !== 32) return;
    e.preventDefault();
    onChange(!checked);
  };
  let defaultStyle = {
    backgroundColor: checked
      ? onColor
        ? onColor
        : 'var(--primary)'
      : offColor
      ? offColor
      : 'var(--secondary)',
  };

  return (
    <div className={'chronos-toggle' + (size ? ' chronos-toggle-' + size : '')}>
      <input
        type="checkbox"
        name={name}
        className="chronos-toggle-checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {id ? (
        <label
          className="chronos-toggle-label"
          tabIndex={disabled ? -1 : 1}
          onKeyDown={handleKeyPress}
          htmlFor={id}
          style={defaultStyle}
        >
          <span
            className={
              disabled
                ? 'chronos-toggle-inner chronos-toggle-disabled'
                : 'chronos-toggle-inner'
            }
            data-yes={onText || 'Yes'}
            data-no={offText || 'No'}
            tabIndex={-1}
          />
          <span
            className={
              disabled
                ? 'chronos-toggle-switch chronos-toggle-switch-disabled'
                : 'chronos-toggle-switch'
            }
            tabIndex={-1}
          />
        </label>
      ) : null}
    </div>
  );
}
